import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";

const propTypes = {
  base: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sm: PropTypes.string,
  md: PropTypes.string,
  lg: PropTypes.string,
  xl: PropTypes.string,
  smOffset: PropTypes.string,
  mdOffset: PropTypes.string,
  lgOffset: PropTypes.string,
  xlOffset: PropTypes.string,
  style: PropTypes.object,
  contAlignment: PropTypes.oneOf(["center", "left", "right"]),
  className: PropTypes.string,
  children: PropTypes.node,
  p: PropTypes.string,
  pt: PropTypes.string,
  pl: PropTypes.string,
  pr: PropTypes.string,
  pb: PropTypes.string,
  ph: PropTypes.string,
  pv: PropTypes.string,
  m: PropTypes.string,
  mt: PropTypes.string,
  ml: PropTypes.string,
  mr: PropTypes.string,
  mb: PropTypes.string,
  mh: PropTypes.string,
  mv: PropTypes.string
};

const defaultProps = {
  base: 1,
  className: "",
  contAlignment: "left"
};

const offsetsClasses = {
  smOffset: "offset-sm-",
  mdOffset: "offset-md-",
  lgOffset: "offset-lg-",
  xlOffset: "offset-xl-"
};
/* compose classes for grid */
const Column = props => {
  let brPoints = ["sm", "md", "lg", "xl"];
  const {
    contAlignment,
    style,
    base,
    p,
    pt,
    pb,
    pl,
    pr,
    ph,
    pv,
    m,
    mh,
    mv,
    mt,
    mb,
    ml,
    mr
  } = props;

  const pureClasses = _.compact(
    brPoints.map(function(br) {
      if (props[br]) {
        return `pure-u-${br}-${props[br]}`;
      }
    })
  ).join(" ");
  /* compose classes for offsets */
  const pureOffsettedClasses = _.compact(
    _.map(offsetsClasses, function(v, k) {
      if (props[k]) {
        return `${v}${props[k]}`;
      }
    })
  ).join(" ");

  const classes = `pure-u-${base} ${pureClasses} ${pureOffsettedClasses} ${props.className}`;
  const styles = {
    paddingLeft: pl || ph,
    paddingRight: pr || ph,
    paddingBottom: pb || pv,
    paddingTop: pt || pv,
    padding: p,
    marginLeft: ml || mh,
    marginRight: mr || mh,
    marginBottom: mb || mv,
    marginTop: mt || mv,
    margin: m,
    textAlign: contAlignment,
    ...props.style
  };

  return (
    <div className={classes} style={_.omitBy(styles, _.isUndefined)}>
      {props.children}
    </div>
  );
};

//Column.propTypes = propTypes
Column.defaultProps = defaultProps;

export default Column;
